// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.step-indicator {
  padding: 0 0 30px;
}

.steps {
  display: flex;
  height: 5px;
  margin-top: 60px;
  position: relative;
}
.steps li {
  -ms-flex: 1;
  -webkit-flex: 1;
  background-color: #d2d2d2;
  color: #767676;
  flex: 1;
  margin-right: 5px;
  outline: 1px solid transparent;
}
.steps li:first-child {
  border-radius: 2.5px 0 0 2.5px;
  border-radius: 2.5px 0 0 2.5px;
  border-radius: 2.5px 0 0 2.5px;
  border-radius: 2.5px 0 0 2.5px;
  border-radius: 2.5px 0 0 2.5px;
}
.steps li:last-child {
  border-radius: 0 2.5px 2.5px 0;
  border-radius: 0 2.5px 2.5px 0;
  border-radius: 0 2.5px 2.5px 0;
  border-radius: 0 2.5px 2.5px 0;
  border-radius: 0 2.5px 2.5px 0;
  margin-right: 0;
}
.steps li.step-done, .steps li.step-on {
  background-color: #007a3e;
  border: 1px solid transparent;
  color: #007a3e;
}
.steps .step-text {
  bottom: 29px;
  display: inline-block;
  font-size: 18px;
  margin-top: 0;
  position: relative;
  white-space: nowrap;
}
.steps .step-on .step-text {
  font-family: "Omnes-ATT-W02-Medium";
}
.steps li .step-text[data-large-text]:before {
  content: attr(data-large-text) "";
}

@media (max-width: 1024px) {
  .step-indicator {
    margin-bottom: 20px;
    margin-left: 0px;
  }
  .steps {
    margin-top: 0;
  }
  .steps .step-text {
    display: none;
  }
  .steps .step-on .step-text {
    bottom: 6px;
    display: block;
    font-size: 12px;
    left: 0;
    line-height: 1;
    margin-top: 10px;
    position: absolute;
    top: 4px;
  }
  .steps li .step-text[data-sm-text]:before {
    color: #333333;
    content: attr(data-sm-text) "";
  }
}
.sr-only {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  padding: 0 !important;
  border: 0 !important;
  white-space: nowrap !important;
  clip: rect(1px 1px 1px 1px) !important; /* IE6, IE7 */
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/step-indicator/stepindicator.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,iBAAA;AAkJF;;AA/IA;EAGE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAkJF;AAhJE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,OAAA;EACA,iBAAA;EACA,8BAAA;AAkJJ;AAhJI;EFYA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;AE2IJ;AAnJI;EFQA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EENE,eAAA;AAyJN;AAtJI;EAEE,yBAAA;EACA,6BAAA;EACA,cAAA;AAuJN;AAnJE;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAqJJ;AAjJI;EACE,mCAAA;AAmJN;AA/IE;EACE,iCAAA;AAiJJ;;AFlLI;EEqCF;IACE,mBAAA;IACA,gBAAA;EAiJF;EA9IA;IACE,aAAA;EAgJF;EA9IE;IACE,aAAA;EAgJJ;EA5II;IACE,WAAA;IACA,cAAA;IACA,eAAA;IACA,OAAA;IACA,cAAA;IACA,gBAAA;IACA,kBAAA;IACA,QAAA;EA8IN;EA1IE;IACE,cAAA;IACA,8BAAA;EA4IJ;AACF;AAvIA;EACE,6BAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,8BAAA;EACA,sCAAA,EAAA,aAAA;EACA,yCAAA;EACA,gCAAA;AAyIF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n// Steps indicator start\n.step-indicator {\n  padding: 0 0 30px;\n}\n\n.steps {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 5px;\n  margin-top: 60px;\n  position: relative;\n\n  li {\n    -ms-flex: 1;\n    -webkit-flex: 1;\n    background-color: color(default, dark);\n    color: #767676;\n    flex: 1;\n    margin-right: 5px;\n    outline: 1px solid transparent;\n\n    &:first-child {\n      @include vendor-prefix('border-radius', 2.5px 0 0 2.5px);\n    }\n\n    &:last-child {\n      @include vendor-prefix('border-radius', 0 2.5px 2.5px 0);\n      margin-right: 0;\n    }\n\n    &.step-done,\n    &.step-on {\n      background-color: #007a3e;\n      border: 1px solid transparent;\n      color: #007a3e;\n    }\n  }\n\n  .step-text {\n    bottom: 29px;\n    display: inline-block;\n    font-size: 18px;\n    margin-top: 0;\n    position: relative;\n    white-space: nowrap;\n  }\n\n  .step-on {\n    .step-text {\n      font-family: 'Omnes-ATT-W02-Medium';\n    }\n  }\n\n  li .step-text[data-large-text]:before {\n    content: attr(data-large-text) '';\n  }\n}\n@include respond-to(small) {\n  .step-indicator {\n    margin-bottom: 20px;\n    margin-left: 0px;\n  }\n\n  .steps {\n    margin-top: 0;\n\n    .step-text {\n      display: none;\n    }\n\n    .step-on {\n      .step-text {\n        bottom: 6px;\n        display: block;\n        font-size: 12px;\n        left: 0;\n        line-height: 1;\n        margin-top: 10px;\n        position: absolute;\n        top: 4px;\n      }\n    }\n\n    li .step-text[data-sm-text]:before {\n      color: color(inverse, dark);\n      content: attr(data-sm-text) '';\n    }\n  }\n}\n\n\n.sr-only {\n  position: absolute !important;\n  height: 1px; \n  width: 1px; \n  overflow: hidden;\n  padding: 0 !important;\n  border: 0! important;\n  white-space: nowrap !important;\n  clip: rect(1px 1px 1px 1px) !important; /* IE6, IE7 */\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  clip-path: inset(50%) !important;\n}\n//steps indicator end\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
